import { render, staticRenderFns } from "./JsPdf.vue?vue&type=template&id=6ed906e0&scoped=true&"
import script from "./JsPdf.vue?vue&type=script&lang=js&"
export * from "./JsPdf.vue?vue&type=script&lang=js&"
import style0 from "./JsPdf.vue?vue&type=style&index=0&id=6ed906e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed906e0",
  null
  
)

export default component.exports